interface TenantEntry {
  tenantId: number | string
  isDemo?: boolean
}

interface UserTenants {
  tenantId?: number | string | null
  tenants?: TenantEntry[]
}

/**
 * True when the onboarding belongs to a further company of an existing user ("Neue Firma erstellen"):
 * the user has another real (non-demo) tenant besides the active one. Those keep the old AVV modal
 * and get neither the short question nor the welcome screen - that is only for new sign-ups.
 */
const isAdditionalTenant = ({ tenantId, tenants = [] }: UserTenants): boolean =>
  tenants.some(tenant => !tenant.isDemo && String(tenant.tenantId) !== String(tenantId))

export default isAdditionalTenant
